import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TransformationSection } from '../components/TransformationSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { PricingSection } from '../components/PricingSection';
import { FooterCTA } from '../components/FooterCTA';
import { DecorativeBackground } from '../components/DecorativeBackground';
export function SalesPage() {
  return <main className="relative w-full min-h-screen bg-cream font-body" data-id="element-140">
      <DecorativeBackground data-id="element-141" />
      <div className="relative z-10" data-id="element-142">
        <HeroSection data-id="element-143" />
        <AudienceSection data-id="element-144" />
        <ProductSection data-id="element-145" />
        <BonusSection data-id="element-146" />
        <TransformationSection data-id="element-147" />
        <GuaranteeSection data-id="element-148" />
        <PricingSection data-id="element-149" />
        <FooterCTA data-id="element-150" />
      </div>
    </main>;
}